// extracted by mini-css-extract-plugin
export default {"header":"WizardTemplate_header__rmo94","footer":"WizardTemplate_footer__Epyr9","btnSeparator":"WizardTemplate_btnSeparator__GE+xV","children":"WizardTemplate_children__T55N+"};